// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yTlT","colBig":"styles_colBig__2RHrF","colSmall":"styles_colSmall__3eXdE"};